
import { Loading } from 'element-ui'
let loading
function startLoading (config) {
  loading = Loading.service({
    lock: true,
    text: config != null && config.data != null && config.data.loadingMessage != null ? config.data.loadingMessage : '加载中...',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
  })
}
function endLoading () {
  loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading (config) {
  if (needLoadingRequestCount === 0) {
    startLoading(config)
  }
  needLoadingRequestCount++
}
export function tryHideFullScreenLoading () {
  if (needLoadingRequestCount <= 0) return
  needLoadingRequestCount--
  if (needLoadingRequestCount === 0) { endLoading() }
}



// WEBPACK FOOTER //
// ./src/components/utils/loading.js